import { Outlet } from 'react-router-dom';
import StepHeader from '../../components/Navigation/StepHeader';
var SignIn = function () {
    return (<div className="flex h-screen w-full flex-col">
      <StepHeader />
      <Outlet />
    </div>);
};
export default SignIn;
